import { Link } from 'react-router-dom';
import { Film } from '@/mocks/films';

interface MovieCardProps {
  film: Film;
  size?: 'normal' | 'large';
}

export default function MovieCard({ film, size = 'normal' }: MovieCardProps) {
  const categoryMap: Record<string, string> = {
    drama: '电视剧',
    movie: '电影',
    variety: '综艺',
    anime: '动漫',
  };

  return (
    <Link
      to={`/article/${film.id}`}
      className="block group cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg bg-background-100 ${
        size === 'large' ? 'aspect-[2/3]' : 'aspect-[2/3]'
      }`}>
        <img
          src={film.coverImage}
          alt={`${film.title} - ${film.englishTitle}`}
          title={`${film.title} ${film.tags.slice(0, 2).join(' ')}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        <div className="absolute top-2 left-2">
          <span className="bg-primary-500 text-background-50 text-[10px] font-bold px-2 py-0.5 rounded whitespace-nowrap">
            {film.rating.toFixed(1)}
          </span>
        </div>

        {film.trending && (
          <div className="absolute top-2 right-2">
            <span className="bg-accent-500 text-background-50 text-[10px] font-medium px-2 py-0.5 rounded whitespace-nowrap">
              热门
            </span>
          </div>
        )}

        {film.newRelease && (
          <div className="absolute top-2 right-2">
            <span className="bg-primary-500 text-background-50 text-[10px] font-medium px-2 py-0.5 rounded whitespace-nowrap">
              新上
            </span>
          </div>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <p className="text-foreground-300 text-xs line-clamp-2 leading-relaxed">
            {film.description.slice(0, 60)}...
          </p>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-10 h-10 rounded-full bg-primary-500/80 flex items-center justify-center">
            <i className="ri-play-fill text-background-50 text-lg ml-0.5"></i>
          </div>
        </div>
      </div>

      <div className="mt-2.5">
        <h3 className="text-foreground-900 text-sm font-medium truncate group-hover:text-primary-500 transition-colors">
          {film.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-foreground-500 text-xs">{categoryMap[film.category]}</span>
          <span className="text-foreground-400 text-[10px]">·</span>
          <span className="text-foreground-500 text-xs">{film.year}</span>
          {size === 'large' && film.episodes && (
            <>
              <span className="text-foreground-400 text-[10px]">·</span>
              <span className="text-foreground-500 text-xs truncate">{film.episodes}</span>
            </>
          )}
        </div>
      </div>
    </Link>
  );
}